import PropTypes from 'prop-types'
import { hideSendInputNotification } from '../../actions/onDemand'

const stateProps = {
  'ondemand.capturingSuspended': PropTypes.bool.isRequired,
  'ondemand.showSendInputDisallowed': PropTypes.bool.isRequired,
}

/**
 * check if this modal should be displayed
 * @param {Object} state - the whole store state
 * @returns {Boolean} - true|false
 */
const shouldDisplay = ({
  ondemand: { capturingSuspended, showSendInputDisallowed },
}) => {
  return (Boolean(showSendInputDisallowed) && !capturingSuspended)
}

/**
 * returns the modal data; this function is called
 * by AppModal only when this modal should be displayed
 * @param {Object} state - store state
 * @param {Function} dispatch - store dispatch
 * @param {Function} translate - i18n.t
 *
 * @returns {Object} - the modal data to be rendered by AppModal
 */
const getModalData = ({ dispatch, state: { agent: { unattended } } }) => {
  return {
    iconClass: 'modal-icon-kvm-suspended',
    title: 'ovl-km-title',
    body: 'ovl-km-message',
    note: `ovl-km-note${unattended ? '-unattended' : ''}`,
    buttons: [{ text: 'btn-ok', onClick: () => dispatch(hideSendInputNotification()) }]
  }
}

export default {
  stateProps,
  shouldDisplay,
  getModalData,
}
